import GamePageTemplate from "../GamePageTemplate";

export const SlotsPage = () => {
  return (
    <GamePageTemplate
      // pageTitle="Slots Lobby"
      // bannerTitle="Slots Lobby"
      bannerImage="/images/slots-banner.png"
      fetchParams={{ isLiveGame: false }}
      showGameTypeFilter={true}
      excludeGameTypes="crash,fish"
    />
  );
};

export default SlotsPage;
